





















import { config } from "@/config";
import { Component, Vue } from "vue-property-decorator";
import { app } from "@/models/Application";

@Component({})
export default class extends Vue {
    public status = app.loginService.status;

    private onLogOut() {
        app.loginService.logout();
        this.$router.push({ name: "login" });
    }

    private onViewProfile() {
        this.$router.push({ path: "profile" });
    }
}
